/**
 * @module profile/components/portfolio/form_info_setp
 */
import React, { PropTypes, Component } from 'react';
import ModalFormStep from 'common/components/form/modal_form_step';
import PortfolioInfoForm from 'profile/containers/portfolio/form_entry_info';

/**
 * Portfolio upload form step component which renders the entry info form.
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class FormInfoStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      entry: { ...props.entry },
    };
  }

  getSidebar() {
    return (
      <div>
        <h3>Thumbnail</h3>
        <img className="thumbnail-wrap" src={this.state.entry.thumbnail} alt="entry thumbnail" />
        <span className="change-revision" onClick={this.props.onChangeEntry}>
          Change
        </span>
      </div>
    );
  }

  getContent() {
    return (
      <PortfolioInfoForm onSubmit={this.props.onFormSubmit} />
    );
  }

  render() {
    return (
      <ModalFormStep
        sidebar={this.getSidebar()}
        content={this.getContent()}
        buttons={this.props.formButtons}
      />
    );
  }
}

FormInfoStep.propTypes = {
  entry: PropTypes.object,
  formButtons: PropTypes.node,
  onChangeEntry: PropTypes.func,
  onFormSubmit: PropTypes.func,
};



// WEBPACK FOOTER //
// ./profile/components/portfolio/form_info_step.jsx